/**
 * @flow
 * @author: Chinmaya
 */
import styled from 'react-emotion'
import {
  Dropdownlist as BaseDropdownlist,
  DropdownContainer as BaseDropdownContainer,
  DropdownItems as BaseDropdownItems
} from '../../StakeHoldersDropdown/styledComponents'

export const DropdownContainer = styled(BaseDropdownContainer)`
  padding: 0px;
  background: transparent;
`

export const Dropdownlist = styled(BaseDropdownlist)`
  position: inherit;
  box-shadow: none;
  padding: 0px;
  border-radius: 0px;
  padding: 0px 3em;
  background: transparent;
`

export const DropdownItems = styled(BaseDropdownItems)`
  align-items: flex-start;
  font-weight: normal;
  button {
    text-align: left;
    &:hover {
      color: #43484c;
      background: transparent;
    }
  }
`
